/**
 * Big number pad for a 4-digit PIN (ONBOARDING J4, the shop tablet). Dots show how many digits are in, never the digits.
 * Calls `onPin` once four are typed, then clears itself so a wrong PIN can be typed again.
 */
import { useState } from "react";
import { Icon } from "./Icons.tsx";

export const PIN_LENGTH = 4;

export function PinPad({ label, onPin, disabled, busy }: { label: string; onPin: (pin: string) => void; disabled?: boolean; busy?: boolean }) {
  const [digits, setDigits] = useState("");
  const off = disabled || busy;
  function press(d: string) {
    if (off) return;
    const next = (digits + d).slice(0, PIN_LENGTH);
    if (next.length === PIN_LENGTH) { setDigits(""); onPin(next); }
    else setDigits(next);
  }
  return (
    <div className="pinpad">
      <p className="pinpad-label" id="pinpad-label">{label}</p>
      <div className="pin-dots" role="img" aria-label={`${digits.length} of ${PIN_LENGTH} numbers typed`}>
        {Array.from({ length: PIN_LENGTH }, (_, i) => <span key={i} className={i < digits.length ? "on" : ""} />)}
      </div>
      <div className="pin-keys" role="group" aria-labelledby="pinpad-label">
        {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((d) => <button key={d} type="button" className="pin-key" disabled={off} onClick={() => press(d)}>{d}</button>)}
        <span aria-hidden="true" />
        <button type="button" className="pin-key" disabled={off} onClick={() => press("0")}>0</button>
        <button type="button" className="pin-key pin-key-quiet" disabled={off || !digits} aria-label="Delete the last number" onClick={() => setDigits(digits.slice(0, -1))}><Icon name="back" /></button>
      </div>
    </div>
  );
}
